export default __webpack_public_path__ + "static/media/INNOMOTICS-logo-power-gray-RGB.07709223.svg";